import React, { useEffect, useState } from 'react'
import './sign-section.scss'
import useMediaQuery from '@/utils/useMediaQuery'
import { StaticImage } from 'gatsby-plugin-image'
import { callModal } from '../modal-viewer/modal-viewer'
import Button from '@/components/atoms/button/button'
import useUserSigned, { requestIfUserHasSign } from '@/hooks/useUserSigned'
import userSessionStorage from '@/context/userSessionStorage'
import { LOCALE_AT, concourseId } from '@/constants/activity-constants'
import SignService from '@/services/sign-service'
import { emitUpdateTotalSigns } from '@/hooks/useTotalSigns'
import { triggerTageo } from '@/utils/tagging-util'
let hasSigned = false
const $ALZA = LOCALE_AT.PARAGUAY ? 'ALZÁ' : 'ALZA'
const $Selecciona = LOCALE_AT.PARAGUAY ? 'Seleccioná' : 'Selecciona'
const $quieras = LOCALE_AT.PARAGUAY ? 'queras' : 'quieras'
const $Firma = LOCALE_AT.PARAGUAY ? 'Firmá' : 'Firma'
const $unete = LOCALE_AT.PARAGUAY ? 'unite' : 'únete'
const $comprometete = LOCALE_AT.PARAGUAY ? 'comprometete' : 'comprométete'
const $COMPARTE = LOCALE_AT.PARAGUAY ? 'COMPARTÍ' : 'COMPARTE'
const agreementsList = [
  'Alzar la voz',
  'Ser parte del cambio',
  'Dar mi apoyo a quien lo necesite',
  'No reírme',
  'Dejar de ser observador',
  'No celebrar o promover el bullying',
]
function ImageMediaSigned() {
  const isMobile = useMediaQuery()
  const commonMedia = {
    alt: 'Niñas apoyandose unas con otras en contra el bullyng',
    className: 'img-media',
  }
  if (isMobile) {
    return (
      <StaticImage
        src="../../../assets/images/sign-section/post-sign-mb.webp"
        placeholder="blurred"
        objectPosition={'center 10%'}
        width={320}
        {...commonMedia}
      />
    )
  }
  return (
    <StaticImage
      src="../../../assets/images/sign-section/post-sign-pc.webp"
      placeholder="blurred"
      width={1440}
      {...commonMedia}
    />
  )
}
function ImageMedia() {
  const isMobile = useMediaQuery()
  const commonMedia = {
    alt: 'Niñas apoyandose unas con otras en contra el bullyng',
    className: 'img-media',
  }
  if (isMobile) {
    return (
      <StaticImage
        src="../../../assets/images/sign-section/pre-sign-mb.webp"
        placeholder="blurred"
        objectPosition={'center 10%'}
        width={320}
        {...commonMedia}
      />
    )
  }
  return (
    <StaticImage
      src="../../../assets/images/sign-section/pre-sign-pc.webp"
      placeholder="blurred"
      width={1440}
      {...commonMedia}
    />
  )
}

function PillCheckBox({
  checked = false,
  children,
  onChange,
}: {
  checked?: boolean
  children: React.ReactNode
  onChange: (checked: boolean) => void
}) {
  const [checkValue, setCheckValue] = useState(checked)

  return (
    <div className={'f-pill-checkbox ' + (checkValue ? 'active' : '')}>
      <label>
        <input
          type="checkbox"
          name="agreement"
          checked={checkValue}
          onChange={evt => {
            setCheckValue(!checkValue)
            onChange(!checkValue)
          }}
        />
        {children}
      </label>
    </div>
  )
}

async function postSign(agreements: string) {
  const token = userSessionStorage.getToken()
  if (!token) {
    return { success: false, errorMessage: 'Usuarios no esta logeado' }
  }
  const config = {
    headers: {
      Authorization: token.idToken,
    },
  }
  return SignService.postSign(concourseId, agreements, config).then(
    response => {
      if (response.status === 200) {
        return { success: true, errorMessage: 'firma guardada' }
      }

      return {
        success: false,
        errorMessage: 'fallo no pudo guardar firma',
        response,
      }
    }
  )
}
function SignSectionHeading({ onUpdate }: { onUpdate: () => void }) {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [agreements, setAgreemets] = useState([agreementsList[0]])

  const pushAgreement = (text: string) => {
    setAgreemets([...agreements, text])
  }
  const popAgreement = (text: string) => {
    agreements.splice(agreements.indexOf(text), 1)
    setAgreemets([...agreements])
  }
  const continueToSign = async () => {
    const allreadySigned = await requestIfUserHasSign()
    if (allreadySigned) {
      onUpdate()
      return
    }
    if (agreements.length === 0) {
      onUpdate()
      return
    }
    postSign(agreements.join('|')).then(response => {
      hasSigned = true
      emitUpdateTotalSigns()
      onUpdate()
      if (response.success) {
        callModal('signed', {})
      } else if (response.errorMessage) {
        setErrorMessage(response.errorMessage)
      }
    })
  }
  const handlerSign = () => {
    if (loading) {
      return
    }
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1000)
    callModal('login', {
      forAccess: 'firmar la petición',
      onClose: (logged: boolean) => {
        if (logged) {
          triggerTageo('11A', {
            label: 'Firma y únete a la camapaña',
            location:
              window.location.host + window.location.pathname + '#firma',
          })
          continueToSign()
        }
      },
    })
  }
  return (
    <div className="f-sign-section__heading">
      <div className="f-sign-section__heading__wrapper">
        <h2 className="title">
          {$ALZA} LA VOZ <br /> CON
          <br /> NOSOTRAS
        </h2>
        <h4 className="subtitle">
          <b>
            {$Firma}, {$unete} y {$comprometete}
          </b>{' '}
          a cambiar el bullying por loving
        </h4>

        <div className="divisor"></div>
        <article className="f-sign-section__join">
          <h5>
            ¡{$Selecciona} las que {$quieras}!
          </h5>
          <h3>me comprometo a:</h3>
          <div className="f-sign-section__agreements">
            {agreementsList.map((agreementText, idx) => (
              <PillCheckBox
                key={'agreement-' + idx}
                checked={agreements.includes(agreementText)}
                onChange={checked => {
                  if (checked) {
                    pushAgreement(agreementText)
                  } else {
                    popAgreement(agreementText)
                  }
                }}
              >
                {agreementText}
              </PillCheckBox>
            ))}
          </div>
          <Button
            title="Firmar"
            onClick={handlerSign}
            loading={loading}
            className={
              'btn-sign ' + (agreements.length === 0 ? '--disabled' : '')
            }
            disabled={loading || agreements.length === 0}
            colorLoading="#ff0087"
          >
            <span className="icon-fist"></span> {$Firma} y {$unete} a la campaña
          </Button>
          {errorMessage && <p className="error-message">{errorMessage} </p>}
        </article>
      </div>
    </div>
  )
}

function SignSectionHeadingSigned() {
  return (
    <div className="f-sign-section__heading --signed">
      <div className="f-sign-section__heading__wrapper">
        <h2 className="title">
          <span className="icon-heart"></span>
        </h2>
        <h2 className="title">¡GRACIAS POR ALZAR LA VOZ CON NOSOTRAS!</h2>
        <h4 className="subtitle">
          {$COMPARTE} ESTA INICIATIVA Y JUNTOS CAMBIEMOS EL BULLYING POR LOVING
        </h4>
      </div>
    </div>
  )
}

export default function SignSection({ id }: { id: string }) {
  const [dirty, setDirty] = useState(1)
  const [serverSigned] = useUserSigned()
  const onUpdate = () => {
    setDirty(current => current * -1)
  }
  const signed = serverSigned || hasSigned
  return (
    <section id={id} className="f-sign-section">
      <div className="wrapper">
        <div className="f-sign-section__media">
          {signed ? <ImageMediaSigned /> : <ImageMedia />}
        </div>
        {signed || hasSigned ? (
          <SignSectionHeadingSigned />
        ) : (
          <SignSectionHeading onUpdate={onUpdate} />
        )}
      </div>
    </section>
  )
}
